import axios from "axios";
import { SERVER_URL } from "../config/config";

class InvoiceServices {
  private static serverURL = SERVER_URL;

  public static async getInvoice(search: any) {
    console.log("InvoiceList");
    let parameteres = search;
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
      params: parameteres,
    };
    console.log("axiosConfig", axiosConfig);
    const apiUrl = `${this.serverURL}/api/order/invoice`;
    const response = await axios.get(apiUrl, axiosConfig);
    return response;
  }

  public static async createMembershipOrderInvoiceSync(body: any) {
    console.log("createMembershipOrderInvoiceSync");
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("createMembershipOrderInvoiceSync", body);

    const apiUrl = `${this.serverURL}/api/order/createinvoice`;
    const response = await axios.post(apiUrl, body, axiosConfig);
    console.log("response", response);
    return response;
  }

  public static async createMembershipPaymentReceiptSync(body: any) {
    console.log("createMembershipPaymentReceiptSync");
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("createMembershipPaymentReceiptSync", body);

    const apiUrl = `${this.serverURL}/api/order/createMembershipPaymentReceipt`;
    const response = await axios.post(apiUrl, body, axiosConfig);
    console.log("createMembershipPaymentReceiptSync response", response);
    return response;
  }

  public static async createOrderInvoiceSync(body: any) {
    console.log("createOrderInvoiceSync");
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("createOrderInvoiceSync", body);

    const apiUrl = `${this.serverURL}/api/order/createeventinvoice`;
    const response = await axios.post(apiUrl, body, axiosConfig);
    console.log("response", response);
    return response;
  }

  public static async createVideoCertificateSync(body: any) {
    console.log("createOrderInvoiceSync");
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        ApiKey: process.env.REACT_APP_API_KEY,
        SessionToken: sessionStorage.getItem("DsbaAdminToken"),
      },
    };
    console.log("createOrderInvoiceSync", body);

    const apiUrl = `${this.serverURL}/api/order/createcertificate`;
    const response = await axios.post(apiUrl, body, axiosConfig);
    console.log("response", response);
    return response;
  }

}



export default InvoiceServices;
